import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  const { settings } = useSiteSettings();
  const wa = settings?.contact?.whatsapp;
  if (!wa) return null;
  const msg = encodeURIComponent(settings?.contact?.whatsapp_prefill || "Hi Way2Efiling, I'd like to know more.");
  const href = `https://wa.me/${wa}?text=${msg}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-6 z-40 group flex items-center gap-2 bg-[#25D366] hover:bg-[#22c55e] text-white rounded-full shadow-lg pl-3 pr-4 py-3 transition-all hover:pr-5"
      style={{ boxShadow: "0 10px 30px -6px rgba(37, 211, 102, 0.55)" }}
    >
      <span className="w-6 h-6 flex items-center justify-center">
        <MessageCircle className="w-5 h-5" fill="currentColor" />
      </span>
      <span className="text-sm font-semibold hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
